export type ThumbState = {
  isDragging: false | 0 | 1;
  hoveredThumb: null | 0 | 1;
  focusedThumb: null | 0 | 1;
};

export type ThumbAction =
  | { type: 'SET_DRAGGING'; payload: false | 0 | 1 }
  | { type: 'SET_HOVERED'; payload: null | 0 | 1 }
  | { type: 'SET_FOCUSED'; payload: null | 0 | 1 };

export function thumbStateReducer(state: ThumbState, action: ThumbAction): ThumbState {
  switch (action.type) {
    case 'SET_DRAGGING':
      return { ...state, isDragging: action.payload };
    case 'SET_HOVERED':
      return { ...state, hoveredThumb: action.payload };
    case 'SET_FOCUSED':
      return { ...state, focusedThumb: action.payload };
    default:
      return state;
  }
}
